document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.quickbuy-product-wrapper').forEach(initQuickBuy);

  function closePopup(wrapper) {
    // Try ancestor first (original behavior)
    let overlay = wrapper.closest('.u-custom-popup-overlay');

    // Fallback: overlay may not be an ancestor (e.g. wrapper rendered inside
    // a popup body that isn't nested under the overlay element itself)
    if (!overlay) {
      overlay = document.querySelector('.u-custom-popup-overlay.active');
    }

    if (overlay) {
      overlay.classList.remove('active');
    } else {
      console.warn('[quickbuy] Could not find popup overlay to close');
    }
  }

  function initQuickBuy(wrapper) {
    const productId = wrapper.dataset.productId;
    const jsonEl = wrapper.querySelector('.ProductJson-' + productId);

    if (!jsonEl) {
      console.warn('[quickbuy] No ProductJson script found for product', productId);
      return;
    }

    const variants = JSON.parse(jsonEl.textContent);

    const variantInput = wrapper.querySelector('.js-variant-id');
    const submitBtn = wrapper.querySelector('.u-buy-btn');
    const price = wrapper.querySelector('.current-price');
    const compare = wrapper.querySelector('.was-price');
    const moneyFormat = wrapper.dataset.moneyFormat || window.money_format || '€';
    const form = wrapper.querySelector('.quickbuy-form');

    if (!variantInput || !submitBtn || !price || !compare || !form) {
      console.warn('[quickbuy] Missing expected elements for product', productId);
      return;
    }

    submitBtn.dataset.defaultText = submitBtn.textContent.trim();

    let selected;
    try {
      selected = JSON.parse(wrapper.dataset.defaultOptions || '[]');
    } catch (e) {
      selected = [];
    }

    // variant.price / compare_at_price from `| json` are already in cents — no *100 here
    function formatPrice(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function norm(v) {
      return (v || '').toString().trim().toLowerCase();
    }

    function findVariant() {
      return variants.find(v =>
        v.options.length === selected.length &&
        v.options.every((opt, i) => norm(opt) === norm(selected[i]))
      );
    }

    function updateUI() {
      const matched = findVariant();
      if (!matched) {
        console.warn('[quickbuy] No variant matched', selected);
        return;
      }

      variantInput.value = matched.id;
      price.textContent = formatPrice(matched.price);

      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        compare.style.display = 'inline';
        compare.textContent = formatPrice(matched.compare_at_price);
      } else {
        compare.style.display = 'none';
      }

      submitBtn.disabled = !matched.available;
      submitBtn.textContent = matched.available ? submitBtn.dataset.defaultText : 'Sold out';
    }

    wrapper.addEventListener('click', function (e) {
      const btn = e.target.closest('.qb-option-btn');
      if (!btn) return;

      const index = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.value;

      btn.closest('.qb-option-values')
        .querySelectorAll('.qb-option-btn')
        .forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const label = wrapper.querySelector(`[data-selected-label="${index}"]`);
      if (label) label.textContent = value;

      selected[index] = value;
      updateUI();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;

      submitBtn.disabled = true;
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';

      const formData = new FormData(form);

      fetch(window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(res => res.json().then(data => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }

          // Notify theme cart drawer/notification to refresh, if present
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('product:added', { detail: data }));

          closePopup(wrapper);
        })
        .catch(err => {
          console.warn('[quickbuy] Add to cart failed', err);
          submitBtn.textContent = 'Error - try again';
        })
        .finally(() => {
          submitBtn.disabled = !findVariant()?.available;
          if (submitBtn.textContent === 'Adding...') {
            submitBtn.textContent = originalText;
          }
        });
    });

    updateUI();
  }

});


document.addEventListener('DOMContentLoaded', function () {

  const popup = document.querySelector('.back-exit-popup');
  if (!popup) return;

  const SESSION_KEY = 'back_exit_popup_shown';
  const PRESS_LOG_KEY = 'back_exit_press_log';
  const CHECKOUT_KEY = 'back_exit_was_on_checkout';

  const MAX_TRAP_ATTEMPTS = 8;
  const CHECKOUT_PATH = '/checkout';

  const triggerPresses =
    parseInt(popup.dataset.triggerPresses, 10) || 3;

  const triggerWindow =
    parseInt(popup.dataset.triggerWindow, 10) || 5000;

  const copyBtn =
    popup.querySelector('.back-exit-popup__copy');

  const closeBtn =
    popup.querySelector('.back-exit-popup__close');


  /*
   * ==========================================================
   * TESTING MODE
   * ==========================================================
   */

  const TESTING_MODE = false;

  if (
    !TESTING_MODE &&
    sessionStorage.getItem(SESSION_KEY) === '1'
  ) {
    return;
  }


  /*
   * ==========================================================
   * STATE
   * ==========================================================
   */

  let trapAttempts = 0;
  let trapping = true;
  let ignoreNextPopstate = false;

  /*
   * TRUE only when popup was opened because the customer
   * returned from checkout.
   */

  let openedFromCheckout = false;


  /*
   * ==========================================================
   * URL HELPERS
   * ==========================================================
   */

  function normalizePath(path) {

    if (!path) return '/';

    if (path.length > 1 && path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    return path;
  }


  function isCheckoutPage(url) {

    try {

      const parsedUrl = new URL(
        url || window.location.href,
        window.location.origin
      );

      const pathname = normalizePath(
        parsedUrl.pathname
      );

      return pathname === CHECKOUT_PATH;

    } catch (e) {

      return false;

    }

  }


  function isCurrentPageCheckout() {
    return isCheckoutPage(
      window.location.href
    );
  }


  /*
   * ==========================================================
   * CHECKOUT FLAG
   * ==========================================================
   */

  function markCheckoutVisited() {

    sessionStorage.setItem(
      CHECKOUT_KEY,
      '1'
    );

  }


  function wasOnCheckout() {

    return (
      sessionStorage.getItem(
        CHECKOUT_KEY
      ) === '1'
    );

  }


  function clearCheckoutFlag() {

    sessionStorage.removeItem(
      CHECKOUT_KEY
    );

  }


  /*
   * ==========================================================
   * BUILD DISCOUNT CHECKOUT URL
   * ==========================================================
   *
   * Example:
   *
   * /discount/SAVE20?redirect=/checkout
   *
   */

  function buildDiscountCheckoutUrl(code) {

    const url = new URL(
      '/discount/' +
      encodeURIComponent(code),
      window.location.origin
    );

    url.searchParams.set(
      'redirect',
      CHECKOUT_PATH
    );

    return url.toString();

  }


  /*
   * ==========================================================
   * RETURN TO CHECKOUT WITH DISCOUNT
   * ==========================================================
   */

  function goBackToCheckout(code) {

    if (!openedFromCheckout) {
      return false;
    }

    if (!code) {
      return false;
    }

    /*
     * Clear state BEFORE redirecting.
     */

    openedFromCheckout = false;

    clearCheckoutFlag();

    /*
     * Redirect through Shopify discount URL.
     *
     * Shopify applies the discount and then redirects
     * customer back to checkout.
     */

    window.location.href =
      buildDiscountCheckoutUrl(code);

    return true;

  }


  /*
   * ==========================================================
   * DETECT CHECKOUT NAVIGATION
   * ==========================================================
   */

  document.addEventListener(
    'click',
    function (e) {

      const target = e.target;


      /*
       * ------------------------------------------------------
       * NORMAL CHECKOUT LINK
       * ------------------------------------------------------
       */

      const link =
        target.closest('a');

      if (link) {

        const href =
          link.getAttribute('href');

        if (
          href &&
          isCheckoutPage(href)
        ) {

          markCheckoutVisited();

        }

      }


      /*
       * ------------------------------------------------------
       * CHECKOUT BUTTON
       * ------------------------------------------------------
       */

      const button =
        target.closest('button');

      if (button) {

        /*
         * Shopify:
         *
         * <button name="checkout">
         */

        if (
          button.name === 'checkout' ||
          button.getAttribute('name') === 'checkout'
        ) {

          markCheckoutVisited();

        }


        /*
         * Apps/themes sometimes use data-checkout.
         */

        if (
          button.hasAttribute('data-checkout')
        ) {

          markCheckoutVisited();

        }


        /*
         * Check parent form.
         */

        const form =
          button.closest('form');

        if (form) {

          const action =
            form.getAttribute('action') || '';

          if (
            isCheckoutPage(action) ||
            form.querySelector(
              '[name="checkout"]'
            )
          ) {

            markCheckoutVisited();

          }

        }

      }

    },
    true
  );


  /*
   * ==========================================================
   * FORM SUBMISSION
   * ==========================================================
   */

  document.addEventListener(
    'submit',
    function (e) {

      const form = e.target;

      if (!form) return;

      const action =
        form.getAttribute('action') || '';

      if (isCheckoutPage(action)) {

        markCheckoutVisited();

        return;

      }

      if (
        form.querySelector(
          '[name="checkout"]'
        )
      ) {

        markCheckoutVisited();

      }

    },
    true
  );


  /*
   * ==========================================================
   * PRESS LOG
   * ==========================================================
   */

  function getPressLog() {

    try {

      return JSON.parse(
        sessionStorage.getItem(
          PRESS_LOG_KEY
        ) || '[]'
      );

    } catch (e) {

      return [];

    }

  }


  function recordPress() {

    const now = Date.now();

    let log = getPressLog();

    log.push(now);

    log = log.filter(function (time) {

      return (
        now - time <= triggerWindow
      );

    });

    sessionStorage.setItem(
      PRESS_LOG_KEY,
      JSON.stringify(log)
    );

    return log.length;

  }


  function clearPressLog() {

    sessionStorage.removeItem(
      PRESS_LOG_KEY
    );

  }


  /*
   * ==========================================================
   * OPEN POPUP
   * ==========================================================
   */

  function openPopup(fromCheckout) {

    /*
     * Never show popup on checkout.
     */

    if (isCurrentPageCheckout()) {
      return;
    }


    openedFromCheckout =
      !!fromCheckout;


    popup.classList.add('active');

    document.body.style.overflow =
      'hidden';


    if (!TESTING_MODE) {

      sessionStorage.setItem(
        SESSION_KEY,
        '1'
      );

      trapping = false;

    }


    clearPressLog();

  }


  /*
   * ==========================================================
   * CLOSE POPUP
   * ==========================================================
   */

  function closePopup() {

    popup.classList.remove(
      'active'
    );

    document.body.style.overflow =
      '';

  }


  /*
   * ==========================================================
   * HISTORY TRAP
   * ==========================================================
   */

  function pushTrapState() {

    history.pushState(
      {
        backExitTrap: true
      },
      '',
      window.location.href
    );

  }


  /*
   * ==========================================================
   * INITIAL NAVIGATION CHECK
   * ==========================================================
   */

  (function checkNavigationType() {

    /*
     * If we're actually on checkout,
     * remember it and stop.
     */

    if (isCurrentPageCheckout()) {

      markCheckoutVisited();

      return;

    }


    const navEntries =
      performance.getEntriesByType(
        'navigation'
      );

    const navType =
      navEntries.length
        ? navEntries[0].type
        : (
            performance.navigation &&
            performance.navigation.type === 2
              ? 'back_forward'
              : null
          );


    /*
     * --------------------------------------------------------
     * RETURNED FROM CHECKOUT
     * --------------------------------------------------------
     */

    if (
      navType === 'back_forward' &&
      wasOnCheckout()
    ) {

      openedFromCheckout = true;

      openPopup(true);

      return;

    }


    /*
     * --------------------------------------------------------
     * NORMAL 3-PRESS LOGIC
     * --------------------------------------------------------
     */

    if (navType === 'back_forward') {

      const count =
        recordPress();

      if (
        count >= triggerPresses
      ) {

        openPopup(false);

      }

    }

  })();


  /*
   * Add trap state on normal storefront pages.
   */

  if (!isCurrentPageCheckout()) {

    pushTrapState();

  }


  /*
   * ==========================================================
   * POPSTATE
   * ==========================================================
   */

  window.addEventListener(
    'popstate',
    function () {

      /*
       * If customer is actually on checkout,
       * remember it but don't show popup.
       */

      if (isCurrentPageCheckout()) {

        markCheckoutVisited();

        return;

      }


      /*
       * Ignore our own history manipulation.
       */

      if (ignoreNextPopstate) {

        ignoreNextPopstate = false;

        pushTrapState();

        return;

      }


      if (!trapping) {
        return;
      }


      /*
       * ======================================================
       * CHECKOUT RETURN
       * ======================================================
       *
       * This has priority over the 3-press system.
       */

      if (wasOnCheckout()) {

        openedFromCheckout = true;

        openPopup(true);

        /*
         * Keep the history trap alive.
         */

        pushTrapState();

        trapAttempts = 0;

        return;

      }


      /*
       * ======================================================
       * NORMAL 3-PRESS SYSTEM
       * ======================================================
       */

      trapAttempts++;

      const count =
        recordPress();


      if (
        count >= triggerPresses
      ) {

        openedFromCheckout = false;

        openPopup(false);

        pushTrapState();

        return;

      }


      /*
       * Stop trapping after maximum attempts
       * when testing mode is disabled.
       */

      if (
        !TESTING_MODE &&
        trapAttempts >= MAX_TRAP_ATTEMPTS
      ) {

        trapping = false;

        return;

      }


      pushTrapState();

    }
  );


  /*
   * ==========================================================
   * COPY DISCOUNT CODE
   * ==========================================================
   */

  if (copyBtn) {

    copyBtn.addEventListener(
      'click',
      function (e) {

        e.stopPropagation();

        const code =
          this.dataset.code;


        /*
         * ----------------------------------------------------
         * FINISH
         * ----------------------------------------------------
         */

        function finish() {

          /*
           * If popup came from checkout:
           *
           * copy code
           * ↓
           * /discount/CODE
           * ↓
           * /checkout
           */

          if (
            goBackToCheckout(code)
          ) {

            return;

          }


          /*
           * Normal 3-press popup:
           * just close it.
           */

          closePopup();

        }


        /*
         * Clipboard API
         */

        if (
          navigator.clipboard &&
          navigator.clipboard.writeText
        ) {

          navigator.clipboard
            .writeText(code)
            .then(finish)
            .catch(function () {

              window.prompt(
                'Kopieer deze code:',
                code
              );

              finish();

            });

        } else {

          window.prompt(
            'Kopieer deze code:',
            code
          );

          finish();

        }

      }
    );

  }


  /*
   * ==========================================================
   * CLOSE BUTTON
   * ==========================================================
   */

  if (closeBtn) {

    closeBtn.addEventListener(
      'click',
      closePopup
    );

  }

});


/*
 * ============================================================
 * QUICK BUY POPUP
 * ============================================================
 *
 * Unrelated system — unchanged.
 */

document.addEventListener(
  'click',
  function (e) {

    const open =
      e.target.closest(
        '.u-cstm-popupbtn'
      );

    if (open) {

      const popup =
        document.querySelector(
          '#popup-' +
          open.dataset.popup
        );

      if (popup) {

        popup.classList.add(
          'active'
        );

        document.body.style.overflow =
          'hidden';

      }

    }


    const close =
      e.target.closest(
        '.u-custom-popup-close'
      );

    if (close) {

      const popup =
        close.closest(
          '.u-custom-popup-overlay'
        );

      if (popup) {

        popup.classList.remove(
          'active'
        );

        document.body.style.overflow =
          '';

      }

    }

  }
);